import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
} from "../../utils/Currency";
import { roundNumber } from "../../services/app";
import { useApp } from "../../contexts";
import { cancelSubShopifyScription } from "../../services/app";
import { dateFormatNumber } from "../../utils/helper";
import { ModalConfirm } from "./ModalConfirm";
import * as Notification from "../../Notification"
import environment from "../../environment";

function ItemBonusV2(props) {
  const {
    T,
    user,
    convertToLocalCurrency,
    formatLocalCurrency,
    getCurrency,
  } = useApp();
  const [isLoading, setIsLoading] = useState(false);
  const { itemData, handleReload } = props;
  const [price, setPrice] = useState(0);
  const [isOpenModalCancel, setIsOpenModalCancel] = useState(false);
  const [isOpenModalCancelSuccess, setIsOpenModalCancelSuccess] = useState(false);
  
  const openModalCancelSubscription = () => {
    setIsOpenModalCancel(true);
  };
  useEffect(() => {
    if (itemData) {
      setPrice(
        convertToLocalCurrency(itemData?.sub?.price, itemData?.sub?.currency_code, getCurrency())
      );
    }
  }, [itemData]);

  const handleCancelSubscription = () => {
    if (isLoading) return;
    setIsLoading(true);
    cancelSubShopifyScription(itemData?.sub?.id)
      .then((res) => {
        setIsLoading(false);
        if (res.data?.data) {
          setIsOpenModalCancel(false);
          handleReload();
          Notification.success(
            T("Success! Your subscription has been canceled!")
          );
        } else {
          Notification.error(T("Failed to cancel subscription"));
        }
      })
      .catch((err) => {
        setIsLoading(false);
        Notification.error(T("Failed to cancel subscription"));
      });
  };
  const handleChangeCard = () => {
    // setSubOrderData({orderId: itemData?.orderId, subscriptionId: itemData?.id});
    // navigate(`/card-information`);
    window.open(
      `${environment.MARKETPLACE_URL}/card-information?subId=${itemData?.id}&senid=${itemData?.orderId}&token=${user?.token}`
    );
  };
  const handleRenew = () => {
    // setSubOrderData({orderId: itemData?.orderId, subscriptionId: itemData?.id});
    // navigate(`/card-information`);
    window.open(
      `${environment.MARKETPLACE_URL}/payment-credix?subId=${itemData?.id}&senid=${itemData?.orderId}&token=${user?.token}`
    );
  };
  return (
    <>
      <div className={`w-auto item-boxs suzu-card !border-none cursor-pointer`}>
        <div
          className={`lg:px-[11px] lg:py-[12px] p-[10px] pb-[14px] rounded-t-[13px] rounded-b-[0] flex flex-col items-center justify-center relative bg-[#F3850F1A]`}
        >
          <div
            className={`lg:text-[16px] xs:text-[14px] tracking-[-0.635px] text-[#000000] font-bold uppercase`}
          >
            <span>{itemData?.sub?.product_name}</span>
          </div>
        </div>
        <div className="mt-[16px] flex items-center justify-center">
          <img src="assets/images/otc/sub-plus-new.svg" alt="" />
        </div>
        <div className="mb-[8px] lg:mb-[14px] lg:mt-[14px] flex items-center justify-center">
          <span className={`text-[16px] text-[#000000]`}>&nbsp;</span>
          <div>
            <span
              className={`text-[#000000] md:text-[24px] lg:text-[24px] xl:text-[24px] text-[28px] font-bold`}
            >
              <NumberFormat
                className=""
                value={formatLocalCurrency(roundNumber(price, 2))}
                displayType={"text"}
                thousandSeparator={true}
                prefix={prefixCcySymbol(true, getCurrency())}
                suffix={suffixCcySymbol(true, getCurrency())}
                decimalScale={validateDecimalSeparator(
                  baseCurrencyCode(true, getCurrency())
                )}
              />
              &nbsp;
            </span>
            <span className={`text-[#000000]`}>/{T("month")}</span>
            <div
              style={{
                borderBottom: "3px solid #000000",
                margin: "0 auto",
              }}
              className="w-[90%]"
            ></div>
          </div>
        </div>

        <div
          className={`flex flex-col items-center lg:px-[20px] h-[78px]
           lg:py-[18px] px-[30px] !pt-[4px] pb-[20px]`}
        >
          {itemData?.dog?.id && (
            <div className="text-black text-sm font-normal">
              {T("Avatar ID: #{eanerId}").replace(
                "{eanerId}",
                itemData?.dog?.id
              )}
            </div>
          )}
          {itemData.sub?.status == 1 && itemData.sub?.user_canceled === 0 && (
            <div
              className="mt-[12px] italic mb-[0px] text-[14px] text-normal text-[#F3850F] text-center hover:underline cursor-pointer"
              onClick={() => {
                openModalCancelSubscription();
              }}
            >
              {T("Cancel Subscription")}
            </div>
          )}
          {/* <div className="w-[100%] lg:w-[150px] max-w-[150px] leading-[35px] xl:text-[16px] lg:text-[14px] text-[14px] flex justify-center items-center">
            {itemData?.sub?.status == 4 ? (
              <button
                className={`w-[100%] h-[100%] rounded-[10px] border border-solid
                ${
                  true
                    ? "text-[#ffffff] bg-[#DEDEDE] border-[#C3C2C2]"
                    : "text-black border-[#000] bg-white"
                } `}
                disabled={true}
              >
                <span>{T("View on Mall")}</span>
              </button>
            ) : (
              <a
                className={`w-[100%] h-[100%] text-center rounded-[10px] border border-solid text-black border-[#000] bg-white`}
                href={itemData?.sub?.detail_url}
                target="_blank"
                rel="noreferrer"
              >
                <span>{T("View on Mall")}</span>
              </a>
            )}
          </div> */}

          {itemData?.sub?.status == 4 && (
            <div className="mt-[12px] italic mb-[5px] text-[14px] text-[#FF5748] text-center">
              {T("Cancelled")}
            </div>
          )}
        </div>
        <div
          className={`bg-[#F3850F1A] rounded-b-[13px] rounded-t-[0] 
        flex justify-center items-center text-[12px] text-black h-[26px] ${
          itemData?.sub?.user_canceled !== 0 ? "!text-[#FF0808]" : ""
        }`}
        >
          {itemData?.sub?.user_canceled === 0
            ? T("Next payment: {date}").replace(
                "{date}",
                dateFormatNumber(itemData?.sub?.end_date_ms, "YYYY/MM/DD")
              )
            : T("Expires on {date}").replace(
                "{date}",
                dateFormatNumber(itemData?.sub?.end_date_ms, "YYYY/MM/DD")
              )}
        </div>
      </div>
      {isOpenModalCancel && (
        <ModalConfirm
          title={T("Cancel Subscription")}
          des={T(
            "Are you sure you want to cancel this subscription? After confirm, the subscription charge will be canceled on {date} and you will not be able to resubscribe to that subscription."
          ).replace(
            "{date}",
            dateFormatNumber(itemData?.sub?.end_date_ms, "YYYY/MM/DD")
          )}
          onClose={() => setIsOpenModalCancel(false)}
          onSubmit={() => handleCancelSubscription()}
          isLoading={isLoading}
        />
      )}
    </>
  );
}

export default ItemBonusV2;
